"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSuggestions = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/scroll/scroll");
/**
 * 채팅 입력 추천 버튼 그룹. 가로 스크롤 가능한 quick-reply 영역.
 * 스크롤과 양 끝의 흐림·넘김 버튼은 mm-scroll(row)이 소유한다.
 *
 * <mm-chat-suggestions>
 *   <mm-chat-suggestion>네, 좋아요</mm-chat-suggestion>
 *   <mm-chat-suggestion>다시 보기</mm-chat-suggestion>
 * </mm-chat-suggestions>
 */
let ChatSuggestions = class ChatSuggestions extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <mm-scroll gap="2" hide-scrollbar>
        <slot></slot>
      </mm-scroll>
    `;
    }
};
ChatSuggestions.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    ::slotted(mm-chat-suggestion) {
      flex-shrink: 0;
    }
  `;
ChatSuggestions = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-suggestions')
], ChatSuggestions);
exports.ChatSuggestions = ChatSuggestions;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhdC1zdWdnZXN0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNoYXQtc3VnZ2VzdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUFpRDtBQUVqRCw2Q0FBMEM7QUFFMUM7Ozs7Ozs7O0dBUUc7QUFFSSxJQUFNLGVBQWUsR0FBckIsTUFBTSxlQUFnQixTQUFRLGdCQUFVO0lBVzdDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7O0tBSVYsQ0FBQTtJQUNILENBQUM7O0FBaEJNLHNCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7O0dBUWxCLENBQUE7QUFUVSxlQUFlO0lBRDNCLElBQUEsNkJBQWEsRUFBQyxxQkFBcUIsQ0FBQztHQUN4QixlQUFlLENBa0IzQjtBQWxCWSwwQ0FBZSJ9